import environment from "@menu-environment";
import { StringDictionary } from "@menu/core/types/string-dictionary";

export const AnalyticsType = {
    topLevel: "top_level_click",
    secondLevel: "secondary_level_click",
    open: "open",
    close: "close",
    menu: "menu_clicks",
    culture: "culture_clicks",
    search: "search_now",
}

type AnalyticsMetaData = {
    component_name: string,
    nav_item: string,
    nav_text: string,
    target_page_url: string
}

const getAnalyticTags = (meta: AnalyticsMetaData) => {
    if (environment.menu.disableAnalytics) {
        return {};
    }

    if (!meta.component_name) {
        console.warn("Analytics - component name is missing: ", meta);
        return {};
    }

    const properties = Object.keys(meta);

    const dict: StringDictionary = {};

    properties.forEach(key => {
        const metaKey = key as keyof typeof meta;
        dict[key] = meta[metaKey].toLowerCase();
    });

    dict.component_type = "links";
    dict.current_page_url = window.location.href;
    dict.nav_location = "header";

    const info = JSON.stringify(dict);

    return {
        "data-component-name": dict.component_name,
        "data-component-info": info
    };
}

export default getAnalyticTags;